import { inject, Injectable } from '@angular/core';
import { WebProviderService } from '../web/web.provider.service';
import { environment } from 'src/environments/environment';
import { StyleImage } from 'src/app/interfaces/style-image';
import { assert } from 'src/app/utils/assert.util';
import { ConfiguredItem } from 'src/app/interfaces/configured-item';

@Injectable({
  providedIn: 'root'
})
export class StyleImagesProviderService {
    protected webProvider = inject(WebProviderService);
    protected readonly baseURL = environment.apiURL;
    protected get attributeURL() {
      return `${this.baseURL}/api/StyleImages/`;
    }

    async getP4s(configuredItem: ConfiguredItem) {
      assert(configuredItem.design, 'No design selected');
      assert(configuredItem.form, 'No form selected');
      assert(configuredItem.primaryMaterial, 'No primary material selected');
      assert(configuredItem.secondaryMaterial, 'No secondary material selected');
      assert(configuredItem.width, 'No width selected');
      const styleImages = await this.webProvider.get<StyleImage[]>(`${this.attributeURL}P4?designID=${configuredItem.design.id}&formID=${configuredItem.form.id}&primaryMaterialID=${configuredItem.primaryMaterial.id}&secondaryMaterialID=${configuredItem.secondaryMaterial.id}&widthID=${configuredItem.width.id}`);
      assert(styleImages, 'Failed to fetch style images');
      return styleImages;
    }

    async getAvailableDesigns(configuredItem: ConfiguredItem) {
      assert(configuredItem.form, 'No form selected');
      assert(configuredItem.primaryMaterial, 'No primary material selected');
      assert(configuredItem.secondaryMaterial, 'No secondary material selected');
      assert(configuredItem.width, 'No width selected');
      const designIDs = await this.webProvider.get<number[]>(`${this.attributeURL}availabledesigns?formID=${configuredItem.form.id}&primaryMaterialID=${configuredItem.primaryMaterial.id}&secondaryMaterialID=${configuredItem.secondaryMaterial.id}&widthID=${configuredItem.width.id}&designation=p4`);
      assert(designIDs, 'Failed to fetch available designs');
      return designIDs;
    }
}
